// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__1rar7","iconContainer":"styles_iconContainer__2Y0O4","icon":"styles_icon__3m41F","text":"styles_text__2Td-V"};